export const isMobileMixin = {
  computed: {
    isMobile() {
      return Math.min(window.screen.width, window.screen.height) < 768;
    },
  },
};
